import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import { app } from "./modules/app";
import { auth } from "./modules/auth";
import { http } from "./modules/http";
import { settings } from "./modules/settings";
import { notificationsGroups } from "./modules/notificationsGroups";
import { reportTemplatesCache } from "./modules/reportTemplatesCache";
import { automaticReportsCache } from "./modules/automaticReportsCache";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "adalytics",
  storage: window.localStorage,
  modules: ["auth", "settings"],
});

export default new Vuex.Store({
  modules: {
    app,
    auth,
    http,
    settings,
    notificationsGroups,
    reportTemplatesCache,
    automaticReportsCache,
  },
  plugins: [vuexPersist.plugin],
});
